/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_portalStaff_requestDeletePortalStaff } from '../models/api_portalStaff_requestDeletePortalStaff';
import type { api_portalStaff_requestGetPortalStaffs } from '../models/api_portalStaff_requestGetPortalStaffs';
import type { api_portalStaff_requestGetPortalStaffsWithOffices } from '../models/api_portalStaff_requestGetPortalStaffsWithOffices';
import type { api_portalStaff_requestImportUnimportedStaffs } from '../models/api_portalStaff_requestImportUnimportedStaffs';
import type { api_portalStaff_requestSavePortalOfficeStaff } from '../models/api_portalStaff_requestSavePortalOfficeStaff';
import type { api_portalStaff_requestSavePortalStaff } from '../models/api_portalStaff_requestSavePortalStaff';
import type { api_portalStaff_requestUpdateIsPublicListing } from '../models/api_portalStaff_requestUpdateIsPublicListing';
import type { api_portalStaff_requestUpdatePortalStaff } from '../models/api_portalStaff_requestUpdatePortalStaff';
import type { api_portalStaff_requestUploadImage } from '../models/api_portalStaff_requestUploadImage';
import type { api_portalStaff_responseDeletePortalStaff } from '../models/api_portalStaff_responseDeletePortalStaff';
import type { api_portalStaff_responseGetJobTypeList } from '../models/api_portalStaff_responseGetJobTypeList';
import type { api_portalStaff_responseGetPortalStaffs } from '../models/api_portalStaff_responseGetPortalStaffs';
import type { api_portalStaff_responseGetPortalStaffsWithOffices } from '../models/api_portalStaff_responseGetPortalStaffsWithOffices';
import type { api_portalStaff_responseGetUnimportedStaffs } from '../models/api_portalStaff_responseGetUnimportedStaffs';
import type { api_portalStaff_responseImportUnimportedStaffs } from '../models/api_portalStaff_responseImportUnimportedStaffs';
import type { api_portalStaff_responseSavePortalOfficeStaff } from '../models/api_portalStaff_responseSavePortalOfficeStaff';
import type { api_portalStaff_responseSavePortalStaff } from '../models/api_portalStaff_responseSavePortalStaff';
import type { api_portalStaff_responseUpdateIsPublicListing } from '../models/api_portalStaff_responseUpdateIsPublicListing';
import type { api_portalStaff_responseUpdatePortalStaff } from '../models/api_portalStaff_responseUpdatePortalStaff';
import type { api_portalStaff_responseUploadImage } from '../models/api_portalStaff_responseUploadImage';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PortalStaffService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Update PortalStaff
     * Update PortalStaff
     * @returns api_portalStaff_responseUpdatePortalStaff responseUpdatePortalStaff
     * @throws ApiError
     */
    public postPortalStaffUpdate({
        body,
    }: {
        /**
         * requestUpdatePortalStaff
         */
        body: api_portalStaff_requestUpdatePortalStaff,
    }): CancelablePromise<api_portalStaff_responseUpdatePortalStaff> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staff/update',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Upload Image(jpeg or png) from portal staff
     * Upload Image(jpeg or png) from portal staff
     * @returns api_portalStaff_responseUploadImage responseUploadImage
     * @throws ApiError
     */
    public postPortalStaffUploadImage({
        body,
    }: {
        /**
         * requestUploadImage
         */
        body: api_portalStaff_requestUploadImage,
    }): CancelablePromise<api_portalStaff_responseUploadImage> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staff/upload_image',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create PortalOffice and PortalStaff
     * Create PortalOffice and PortalStaff
     * @returns api_portalStaff_responseSavePortalOfficeStaff responseSavePortalOfficeStaff
     * @throws ApiError
     */
    public postPortalStaffsCreateWithPortalOffice({
        body,
    }: {
        /**
         * requestSavePortalOfficeStaff
         */
        body: api_portalStaff_requestSavePortalOfficeStaff,
    }): CancelablePromise<api_portalStaff_responseSavePortalOfficeStaff> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staffs/create_with_portal_office',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete PortalStaff
     * Delete PortalStaff
     * @returns api_portalStaff_responseDeletePortalStaff responseDeletePortalStaff
     * @throws ApiError
     */
    public postPortalStaffsDelete({
        body,
    }: {
        /**
         * requestDeletePortalStaff
         */
        body: api_portalStaff_requestDeletePortalStaff,
    }): CancelablePromise<api_portalStaff_responseDeletePortalStaff> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staffs/delete',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get PortalStaff list by PortalOfficeId
     * Get PortalStaff list by PortalOfficeId
     * @returns api_portalStaff_responseGetPortalStaffs responseGetPortalStaffs
     * @throws ApiError
     */
    public postPortalStaffsGet({
        body,
    }: {
        /**
         * requestGetPortalStaffs
         */
        body: api_portalStaff_requestGetPortalStaffs,
    }): CancelablePromise<api_portalStaff_responseGetPortalStaffs> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staffs/get',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get JobType List
     * 画面でのプルダウン表示用に、掲載スタッフが選択可能な職業タイプのリストを取得する
     * @returns api_portalStaff_responseGetJobTypeList responseGetJobTypeList
     * @throws ApiError
     */
    public postPortalStaffsGetJobTypeList(): CancelablePromise<api_portalStaff_responseGetJobTypeList> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staffs/get_job_type_list',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Unimported Staff List
     * iBow事業所からポータル事業所に未取り込みのスタッフ一覧を取得する（掲載スタッフかつiBow会員のみ利用可能）
     * @returns api_portalStaff_responseGetUnimportedStaffs responseGetUnimportedStaffs
     * @throws ApiError
     */
    public postPortalStaffsGetUnimportedStaffs(): CancelablePromise<api_portalStaff_responseGetUnimportedStaffs> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staffs/get_unimported_staffs',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get PortalStaff with PortalOffice, Organization List
     * Get PortalStaff with PortalOffice, Organization List
     * @returns api_portalStaff_responseGetPortalStaffsWithOffices responseGetPortalStaffsWithOffices
     * @throws ApiError
     */
    public postPortalStaffsGetWithOffice({
        body,
    }: {
        /**
         * requestGetPortalStaffsWithOffices
         */
        body: api_portalStaff_requestGetPortalStaffsWithOffices,
    }): CancelablePromise<api_portalStaff_responseGetPortalStaffsWithOffices> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staffs/get_with_office',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Import Unimported Staffs
     * 未取り込みのスタッフをiBow事業所からポータル事業所に取り込む
     * @returns api_portalStaff_responseImportUnimportedStaffs responseImportUnimportedStaffs
     * @throws ApiError
     */
    public postPortalStaffsImportUnimportedStaffs({
        body,
    }: {
        /**
         * requestImportUnimportedStaffs
         */
        body: api_portalStaff_requestImportUnimportedStaffs,
    }): CancelablePromise<api_portalStaff_responseImportUnimportedStaffs> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staffs/import_unimported_staffs',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Save PortalStaff
     * 掲載スタッフを保存する。招待トークンが指定された場合、該当の招待を完了に更新する。
     * @returns api_portalStaff_responseSavePortalStaff responseSavePortalStaff
     * @throws ApiError
     */
    public postPortalStaffsSave({
        body,
    }: {
        /**
         * requestSavePortalStaff
         */
        body: api_portalStaff_requestSavePortalStaff,
    }): CancelablePromise<api_portalStaff_responseSavePortalStaff> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staffs/save',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update IsPublicListing
     * ポータルスタッフを外部表示または外部非表示に更新する。
     * @returns api_portalStaff_responseUpdateIsPublicListing responseUpdateIsPublicListing
     * @throws ApiError
     */
    public postPortalStaffsUpdateIsPublicListing({
        body,
    }: {
        /**
         * requestUpdateIsPublicListing
         */
        body: api_portalStaff_requestUpdateIsPublicListing,
    }): CancelablePromise<api_portalStaff_responseUpdateIsPublicListing> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_staffs/update_is_public_listing',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
